import React from 'react'
import { Container } from 'semantic-ui-react';
import { TableRow, TableBody, TableHeader, TableHeaderCell, Table, TableCell } from "semantic-ui-react";


export function AsesorViewa(props) {
  const { mag } = props;
  return (
    <div className='cotizacion-principal'>
      <Container className='cotizacion-principal_info'>
        <p>Cotización: <span className='cotizacion-principal_info-dxp'>{mag.folio}</span></p>
        <p>CardCode Cliente: <span className='cotizacion-principal_info-cliente'>{mag.cardcode}</span></p>
        <p>Nombre del Cliente: <span className='cotizacion-principal_info-cliente'>{mag.cliente}</span></p>
        <p>Clave Existente: <span className='cotizacion-principal_info-clave_ex'>{mag.clave_ex}</span></p>
        <p>Presentaciones: <span className='cotizacion-principal_info-presentacion'>{mag.presentacion}</span></p>
        <Table className='table-precio'>
              <TableHeader>
                  <TableRow>
                      <TableHeaderCell>Presentaciones</TableHeaderCell>
                      <TableHeaderCell>Precios</TableHeaderCell>
                  </TableRow>
              </TableHeader>
              <TableBody>
                  <TableRow>
                      <TableCell>7.5 ML</TableCell>
                      <TableCell>{mag.precio1}</TableCell>
                  </TableRow>
                  <TableRow>
                      <TableCell>15 ML</TableCell>
                      <TableCell>{mag.precio2}</TableCell>
                  </TableRow>
                  <TableRow>
                      <TableCell>30 ML</TableCell>
                      <TableCell>{mag.precio3}</TableCell>
                  </TableRow>
                  <TableRow>
                      <TableCell>60 ML</TableCell>
                      <TableCell>{mag.precio4}</TableCell>
                  </TableRow>
                  <TableRow>
                      <TableCell>120 ML</TableCell>
                      <TableCell>{mag.precio5}</TableCell>
                  </TableRow>
                  <TableRow>
                      <TableCell>240 ML</TableCell>
                      <TableCell>{mag.precio6}</TableCell>
                  </TableRow>
                  <TableRow>
                      <TableCell>480 ML</TableCell>
                      <TableCell>{mag.precio7}</TableCell>
                  </TableRow>
                  <TableRow>
                      <TableCell>960 ML</TableCell>
                      <TableCell>{mag.precio8}</TableCell>
                  </TableRow>
              </TableBody>
          </Table>    
          <div class="leyenda">
            Los precios no incluyen IVA
        </div>
      </Container>
    </div>
  )
}
